import { Input, Component, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../utils/re-base-data';
import { TrackingService } from '../../../bdo/services/tracking.service';

@Component({
    selector: 'bdo-home-link',
    templateUrl: './home-link.component.html',
    styleUrls: ['./home-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeLinkComponent {
  @Input() tracking: Array<string> = [];
  protected reBaseData = ReBaseData;

  constructor(
    private trackingService: TrackingService
  ) { }

  onClick() {
    if (this.tracking.length > 0) {
      this.trackingService.postSimpleTracking(...this.tracking);
    }
  }

}
